<template>
    <div class="cooking-tab">
        <p v-if="groups.length === 0" class="cooking-tab__empty">{{ $t('phu_production.equipment.empty') }}</p>

        <div v-else class="cooking-tab__groups">
            <section v-for="group in groups" :key="group.type" class="cooking-tab__panel">
                <h2 class="cooking-tab__title">{{ group.name }}</h2>
                <div class="cooking-tab__grid">
                    <EquipmentCard
                        v-for="item in group.items"
                        :key="item.id"
                        :equipment="item"
                        :product="item.cooking ? products[item.cooking.product_id] : null"
                        :now="now"
                        :highlighted="item.workstation_id === highlightWorkstationId"
                        @toggle="$emit('toggle', $event)"
                    />
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import EquipmentCard from './EquipmentCard.vue'
import { WORKSTATIONS } from '@/store/static/phuProduction'

export default {
    name: 'CookingTab',
    components: { EquipmentCard },
    props: {
        equipment: { type: Array, required: true },
        catalog: { type: Array, required: true },
        products: { type: Object, required: true },
        now: { type: Number, required: true },
        highlightWorkstationId: { type: Number, default: null }
    },
    computed: {
        groups() {
            return this.catalog.reduce((acc, item) => {
                const workstation = WORKSTATIONS.find((entry) => entry.type === item.type)
                const items = this.equipment.filter((equipment) => workstation && equipment.workstation_id === workstation.id)
                if (items.length > 0) {
                    acc.push({ type: item.type, name: item.name, items })
                }
                return acc
            }, [])
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.cooking-tab {
    &__groups {
        @include display-flex();
        @include flex-direction(column);
        gap: 16px;
    }

    &__panel {
        border: 1px solid $neutro-dark;
        border-radius: $phu-radius-s;
        background-color: $phu-surface;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.06);
        overflow: hidden;
    }

    &__title {
        margin: 0;
        padding: 16px 16px 4px;
        font-family: $text-bold;
        font-size: 1rem;
        line-height: 20px;
        color: $phu-text;
    }

    &__grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax($phu-equipment-card-min, 1fr));
        grid-auto-rows: minmax($phu-equipment-card-height, auto);
        align-items: stretch;
        gap: $phu-gap;
        padding: 4px $phu-gap $phu-gap;
    }

    &__empty {
        padding: 32px;
        font-family: $text;
        font-size: 1rem;
        text-align: center;
        color: $phu-text-muted;
    }
}
</style>
